import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Select from './Select'
import { clearPersons, getPersons } from '../../../../actions'
import { DOCUMENT_TYPE } from '../../../../config/constants'

const PersonSelect = ({ options, loading, noOptionsMessage, dispatchGetPersons, dispatchClearPersons,
  indexGroup, focusIndex, index, onInputChange, ...props }) => {

  const type = useRef("SCANNER"); // SCANNER | TYPING

  const handleInputChange = async (inputValue) => {
    if (onInputChange) {
      onInputChange(inputValue, type.current);
      type.current = "TYPING";
    }
  }

  useEffect(() => () => {
    dispatchClearPersons();
  }, []);


  return (
    <Select
      options={options}
      isLoading={loading}
      noOptionsMessage={noOptionsMessage}
      onInputChange={handleInputChange}
      {...props}
    />
  )
}

PersonSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    idDocumentNumber: PropTypes.string,
    identificationTypeId: PropTypes.string,
    identificationTypeName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    source: PropTypes.string,
  })),
  loading: PropTypes.bool,
  noOptionsMessage: PropTypes.func,
  dispatchGetPersons: PropTypes.func.isRequired,
  dispatchClearPersons: PropTypes.func.isRequired,
  indexGroup: PropTypes.number,
  focusIndex: PropTypes.number,
  index: PropTypes.number,
  onInputChange: PropTypes.func,
}

PersonSelect.defaultProps = {
  options: [],
  loading: false,
  noOptionsMessage: undefined,
  indexGroup: undefined,
  index: undefined,
  onInputChange: undefined,
  focusIndex: null,
}

const mapStateToProps = ({ UserUnit }) => ({
  options: UserUnit.Person.getIn(['all', 'content', 'content']).map(p => {
    const firstName = p.firstName ? p.firstName : '';
    const lastName = p.lastName ? p.lastName : '';
    const idDocumentNumber = p.idDocumentNumber ? p.idDocumentNumber : '';


    let identificationTypeName = null;
    let identificationTypeId = null;
    let idCountryOfOrigin = null;

    if (p.source === 'CUSTOMER') {
      identificationTypeName = p.identificationTypeName ? p.identificationTypeName : '-';
      identificationTypeId = p.identificationTypeId ? p.identificationTypeId : '-';
      idCountryOfOrigin = p.idCountryOfOrigin ? p.idCountryOfOrigin : '-';
    } else {
      identificationTypeName = DOCUMENT_TYPE.DNI.label;
      identificationTypeId = DOCUMENT_TYPE.DNI.value;
      idCountryOfOrigin = "PE";
    }

    const { id, source, dob, countryCode, countryName, mobilePhone } = p;

    return ({
      value: `${id}-${source}`,
      label: `${firstName} ${lastName} | ${identificationTypeName}: ${idDocumentNumber} (${idCountryOfOrigin})`,
      idDocumentNumber,
      identificationTypeName,
      identificationTypeId,
      firstName,
      lastName,
      id,
      source,
      dob,
      idCountryOfOrigin,
      countryCode,
      countryName,
      mobilePhone
    })
  }),
  loading: UserUnit.Person.getIn(['all', 'loading']),
  focusIndex: UserUnit.Person.getIn(['inputFocus', 'index']),
})

const mapDispatchToProps = {
  dispatchGetPersons: getPersons,
  dispatchClearPersons: clearPersons,
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonSelect)